import { render, staticRenderFns } from "./pullnew.vue?vue&type=template&id=632c8b28&scoped=true"
import script from "./pullnew.vue?vue&type=script&lang=js"
export * from "./pullnew.vue?vue&type=script&lang=js"
import style0 from "./pullnew.vue?vue&type=style&index=0&id=632c8b28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632c8b28",
  null
  
)

export default component.exports